<div class="popup-container">
  <div class="bg-color">
    <div class="header col-lg-12 col-md-12 text-center d-flex justify-content-between">
      <div class="left-logo">
        <img class="left-image" src="../../../assets/images/navbar-logo2.png" alt="" />
      </div>

      <div class="warning pt-2 pb-2">
        <p class="font">Important Notice</p>
      </div>

      <div class="side-logo">
        <img class="side-image" src="../../../assets/images/side-logo-1.png" alt="" />
      </div>
    </div>

    <div class="watchlist-spacer col-lg-12 col-md-12 col-sm-12 text-center mb-4 mt-4 text-danger"></div>

    <div class="box-content">
      <p class="watchlist-description">
        Please be informed that you are required to prepare and present the following documents upon arrival in
        the Lao PDR for immigration inspection:
      </p>
      <div class="card-checkbox">
        <ul class="doc-list">
          <li>
            <input type="checkbox" class="doc-checkbox" [(ngModel)]="docChecks.funds" name="docFunds" />
            <span class="text-color">&nbsp;Proof of Sufficient Funds</span>
          </li>
          <li>
            <input type="checkbox" class="doc-checkbox" [(ngModel)]="docChecks.itinerary" name="docItinerary" />
            <span class="text-color">&nbsp;Travel Itinerary</span>
          </li>
          <li>
            <input type="checkbox" class="doc-checkbox" [(ngModel)]="docChecks.hotel" name="docHotel" />
            <span class="text-color">&nbsp;Hotel Booking Confirmation</span>
          </li>
          <li>
            <input type="checkbox" class="doc-checkbox" [(ngModel)]="docChecks.flight" name="docFlight" />
            <span class="text-color">&nbsp;Return or Onward Flight Ticket</span>
          </li>
        </ul>
      </div>


      <div class="ack-box">
        I acknowledge and confirm that I must prepare these documents and present them to the immigration upon
        arrival in the Lao PDR.
      </div>
      <div class="watchlist-ack-row">
        <input id="watchlistAcknowledge" type="checkbox" [(ngModel)]="docChecks.isAcknowledged"
          class="watchlist-checkbox" />
        <label for="watchlistAcknowledge" class="watchlist-label">
          I understand and confirm
        </label>
      </div>

      <div class="watchlist-confirm-row">
        <button class="btn btn-confirm" [disabled]="!areAllDocsChecked" (click)="onContinue()" type="button">
          CONFIRM
        </button>
      </div>

      <div class="watchlist-warning-text">
        Failure to provide these documents may result in denial of entry.
      </div>
    </div>

    <div class="space"></div>
  </div>
</div>